import { PRIVILEGED_ROLES, roleDepartment } from './roles';

export const normalizeDepartment = (value = '') => {
  const normalized = String(value || '').toLowerCase().trim();
  if (normalized.startsWith('sales')) return 'sales';
  if (normalized.startsWith('ret') || normalized.includes('retention')) return 'retention';
  return normalized;
};

export const getAgentDepartment = (agent) => {
  const roleDept = roleDepartment(agent?.role);
  if (roleDept) return roleDept;

  const profileDept = normalizeDepartment(agent?.department);
  return ['sales', 'retention'].includes(profileDept) ? profileDept : null;
};

export const getAssignmentDepartment = (agent, fallback = 'sales') => (
  getAgentDepartment(agent) || fallback
);

export const getAssignmentStatusDepartment = (actorRole, agent, selected = 'sales') => (
  PRIVILEGED_ROLES.includes(actorRole)
    ? selected
    : getAssignmentDepartment(agent, selected)
);
